<div class="aurora-field account-shell" role="application">
  @if (isCompactViewport() && !isSidebarCollapsed()) {
  <button
    type="button"
    class="account-sidebar-backdrop"
    (click)="collapseSidebarForMobile()"
    aria-label="Menüyü kapat"
  ></button>
  }

  <aside
    class="account-sidebar"
    [class.collapsed]="isSidebarCollapsed()"
    [class.is-drawer-open]="isCompactViewport() && !isSidebarCollapsed()"
  >
    <div class="account-sidebar-inner">
      <div class="brand">
        <div class="brand-mark" aria-hidden="true">
          <svg lucideShield [size]="19" [strokeWidth]="2"></svg>
        </div>
        @if (!isSidebarCollapsed()) {
        <div class="brand-copy">
          <strong>Dental Portal</strong>
          <small>Yönetim</small>
        </div>
        }
      </div>

      <nav class="account-sidebar-nav" role="navigation" aria-label="Portal menü">
        @for (item of portalMenuItems; track item.route) {
        <a
          [routerLink]="item.route"
          class="nav-item"
          [class.active]="isActiveRoute(item.route)"
          [attr.title]="item.label"
          (click)="onNavItemClick()"
        >
          @switch (item.route) {
            @case ('/') {
              <svg lucideLayoutDashboard [size]="18" [strokeWidth]="2"></svg>
            }
            @case ('/static-files') {
              <svg lucideFile [size]="18" [strokeWidth]="2"></svg>
            }
            @case ('/properties') {
              <svg lucideSlidersHorizontal [size]="18" [strokeWidth]="2"></svg>
            }
            @case ('/users') {
              <svg lucideUsers [size]="18" [strokeWidth]="2"></svg>
            }
            @case ('/products') {
              <svg lucidePackage [size]="18" [strokeWidth]="2"></svg>
            }
            @case ('/categories') {
              <svg lucideLayers [size]="18" [strokeWidth]="2"></svg>
            }
            @case ('/machine-models') {
              <svg lucideSettings2 [size]="18" [strokeWidth]="2"></svg>
            }
            @case ('/machine-types') {
              <svg lucideCpu [size]="18" [strokeWidth]="2"></svg>
            }
            @case ('/brands') {
              <svg lucideTag [size]="18" [strokeWidth]="2"></svg>
            }
            @case ('/roles') {
              <svg lucideShieldCheck [size]="18" [strokeWidth]="2"></svg>
            }
            @case ('/permissions') {
              <svg lucideKeyRound [size]="18" [strokeWidth]="2"></svg>
            }
            @case ('/packages') {
              <svg lucideBoxes [size]="18" [strokeWidth]="2"></svg>
            }
            @case ('/package-contents') {
              <svg lucideListChecks [size]="18" [strokeWidth]="2"></svg>
            }
            @default {
              <svg lucideLayoutDashboard [size]="18" [strokeWidth]="2"></svg>
            }
          }
          @if (!isSidebarCollapsed()) {
          <span class="nav-item-label">{{ item.label }}</span>
          }
        </a>
        }
      </nav>

      <div class="account-sidebar-footer">
        <button
          type="button"
          class="nav-item collapse-toggle"
          (click)="toggleSidebarCollapsed()"
          [attr.aria-label]="isSidebarCollapsed() ? 'Menüyü genişlet' : 'Menüyü daralt'"
          [attr.title]="isSidebarCollapsed() ? 'Menüyü genişlet' : 'Menüyü daralt'"
        >
          @if (isSidebarCollapsed()) {
            <svg lucidePanelsTopLeft [size]="18" [strokeWidth]="2"></svg>
          } @else {
            <svg lucideChevronsLeft [size]="18" [strokeWidth]="2"></svg>
          }
        </button>
      </div>
    </div>
  </aside>

  <main class="account-canvas">
    <header class="account-topbar" role="banner">
      <div class="account-layout-rail account-topbar-rail account-topbar-rail-end">
        <div class="topbar-actions">
          <div class="user-menu-container">
            <button
              type="button"
              class="topbar-profile-pill"
              [attr.title]="userFullName"
              aria-label="Profil menüsü"
              [attr.data-state]="isUserDropdownOpen() ? 'open' : null"
              [attr.aria-expanded]="isUserDropdownOpen()"
              (click)="toggleUserDropdown(); $event.stopPropagation()"
            >
              <span class="topbar-profile-photo" aria-hidden="true">
                @if (userAvatarUrl() && !avatarImageFailed()) {
                <img
                  [src]="userAvatarUrl()"
                  alt=""
                  class="topbar-profile-photo-img"
                  (error)="onAvatarImageError()"
                />
                } @else {
                <span class="topbar-profile-initials">{{ userInitials || '?' }}</span>
                }
              </span>
              <span class="topbar-profile-copy">
                <span class="topbar-profile-name">{{ userFullName || 'Admin' }}</span>
              </span>
              <svg lucideChevronDown [size]="14" [strokeWidth]="2"></svg>
            </button>

            @if (isUserDropdownOpen()) {
            <div
              class="account-row-menu settings-avatar-menu user-dropdown"
              role="menu"
              aria-orientation="vertical"
              data-side="bottom"
              data-align="end"
              data-state="open"
            >
              <div class="profile-menu-header">
                <span class="profile-menu-name">{{ userFullName }}</span>
                @if (userEmail) {
                <span class="profile-menu-email">{{ userEmail }}</span>
                }
              </div>
              <div role="separator" aria-orientation="horizontal" data-slot="dropdown-menu-separator"></div>
              <button
                type="button"
                role="menuitem"
                data-slot="dropdown-menu-item"
                data-variant="destructive"
                (click)="logout()"
              >
                <svg lucideLogOut [size]="16" [strokeWidth]="1.85" aria-hidden="true"></svg>
                Çıkış Yap
              </button>
            </div>
            }
          </div>
        </div>
      </div>
    </header>

    <div class="account-scroll">
      <div class="account-layout-rail account-page-rail portal-page">
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>
</div>
